import { fontUrl } from '../theme/tenant';
var fontLinkId = 'storybook-font-link-tag';
var loadFont = function loadFont() {
  if (!document.getElementById(fontLinkId)) {
    var fontLink = document.createElement('link');
    fontLink.id = fontLinkId;
    fontLink.href = fontUrl;
    fontLink.rel = 'stylesheet';
    document.head.appendChild(fontLink);
  }
};
export default loadFont;